/* LFJ site tracking (2026-10-06). Loaded on every storefront page (layout/lfj-story + snippets/meta-tags for theme.liquid pages).
   Sends events through Shopify's customer events, so the "LFJ gallery events Google" pixel forwards them to GA4
   and the Meta pixel forwards them as LFJ_<name>. Nothing here changes links or adds anything to URLs.
   Events:
     link_click    every link click: link_url, link_path, link_text, link_area (part of the page), link_type (internal, outbound, email, phone)
     section_view  first time a main section of the page scrolls into view: section
     scroll_depth  25 / 50 / 75 / 100 percent of the page reached: percent
     read_depth    Journal posts only, how far into the article text: percent, article
*/
(function () {
  if (window.__lfjTrack) return;
  window.__lfjTrack = true;

  function send(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('lfj:' + name, data || {}); } catch (e) {}
  }
  function clean(t, n) { return (t || '').replace(/\s+/g, ' ').trim().slice(0, n || 100); }
  function areaOf(el) {
    var host = el.closest('header,footer,nav,aside,section,article,figure,details,[id]');
    while (host) {
      var label = host.id || (typeof host.className === 'string' && host.className.split(' ')[0]) || '';
      if (label && label !== 'shopify-section' && label.indexOf('shopify-section-') !== 0) return clean(label.toLowerCase(), 50);
      if (host.tagName === 'HEADER' || host.tagName === 'FOOTER' || host.tagName === 'NAV') return host.tagName.toLowerCase();
      host = host.parentElement && host.parentElement.closest('header,footer,nav,aside,section,article,figure,details,[id]');
    }
    return 'page';
  }

  // Link clicks
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#' && href.length < 2 || href.indexOf('javascript:') === 0) return;
    var type = 'internal', url = a.href, path = '';
    if (href.indexOf('mailto:') === 0) type = 'email';
    else if (href.indexOf('tel:') === 0) type = 'phone';
    else {
      try { var u = new URL(a.href, location.href); path = u.pathname + u.hash; if (u.host.replace(/^www\./, '') !== location.host.replace(/^www\./, '')) type = 'outbound'; } catch (err) {}
    }
    var img = a.querySelector('img');
    var text = clean(a.innerText) || clean(a.getAttribute('aria-label')) || (img && clean(img.getAttribute('alt'))) || '(image)';
    send('link_click', { link_url: url, link_path: path, link_text: text, link_area: areaOf(a), link_type: type });
  }, true);

  // Section views: main blocks of the page, once each
  function watchSections() {
    if (!('IntersectionObserver' in window)) return;
    var seen = {};
    var els = document.querySelectorAll('main section, main > aside, .lfj-claim, .lgb, footer');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var hd = en.target.querySelector('h1,h2,h3');
        var name = en.target.id || (hd && clean(hd.innerText, 40)) || (typeof en.target.className === 'string' && en.target.className.split(' ')[0]) || en.target.tagName;
        name = clean(String(name).toLowerCase(), 50);
        io.unobserve(en.target);
        if (!name || seen[name]) return;
        seen[name] = 1;
        send('section_view', { section: name });
      });
    }, { threshold: 0.35 });
    for (var i = 0; i < els.length; i++) io.observe(els[i]);
  }

  // Scroll depth (whole page) and read depth (Journal article text)
  function watchScroll() {
    var marks = [25, 50, 75, 100], hit = {}, rHit = {};
    var body = document.querySelector('.lj-body');
    var title = clean((document.querySelector('.lj-title') || {}).innerText, 120);
    var ticking = false;
    function check() {
      ticking = false;
      var doc = document.documentElement;
      var max = Math.max(doc.scrollHeight - window.innerHeight, 1);
      var pct = Math.min(100, Math.round(window.scrollY / max * 100));
      marks.forEach(function (m) { if (pct >= m && !hit[m]) { hit[m] = 1; send('scroll_depth', { percent: m }); } });
      if (body) {
        var r = body.getBoundingClientRect();
        var read = Math.min(100, Math.max(0, Math.round((window.innerHeight - r.top) / Math.max(r.height, 1) * 100)));
        marks.forEach(function (m) { if (read >= m && !rHit[m]) { rHit[m] = 1; send('read_depth', { percent: m, article: title }); } });
      }
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
  }

  function start() { watchSections(); watchScroll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
